var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.subListKeepAlive)?_c('div',[_c('workbench',{attrs:{"api":"coopLoanIouCollateral","query":_vm.query,"columns":_vm.columns,"toolbar":_vm.toolbar},on:{"editData":_vm.editData,"addData":_vm.editData}})],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }